import { CheckoutStepType } from '@src/features/checkout';
import React from 'react';
import styled from 'styled-components';
import { getContrastColorFrom } from '../../common/colors';
import { useTranslate } from '../../core/hooks';
import { ProductStepType } from '../../features/product';
import type { RescheduleStepsType } from '@src/features/rescheduleReducer';
import { BodyLargeBold, BodyRegularMedium } from '../../fonts/typography/Typography';

export type StepTypes = 'product' | 'checkout' | 'reschedule';
interface StepNavigationIconProps {
  number: number;
  stepType: StepTypes;
  type: string;
  isActive?: boolean;
  mainColor: string;
  colorTitle?: string;
  reverseColor?: boolean;
}
const StepNavigationIcon = ({
  number,
  stepType,
  type,
  isActive,
  mainColor,
  colorTitle,
  reverseColor,
}: StepNavigationIconProps) => {
  const { i18n } = useTranslate();

  const textColor = getContrastColorFrom(mainColor);

  const formatTitle = (stepType: StepTypes, type: string): string => {
    switch (stepType) {
      case 'product':
        return i18n(`adder_step_${type as ProductStepType}`);
      case 'checkout':
        return i18n(`checkout_step_${type as CheckoutStepType}`);

      case 'reschedule':
        return i18n(`reschedule_step_${type as RescheduleStepsType}`);
      default:
        return '';
    }
  };

  return (
    <NavigationIconContainer>
      <StepNumber
        isActive={isActive}
        accentColor={reverseColor ? textColor : mainColor}
        color={reverseColor ? mainColor : textColor}
        aria-label={`${type}_${number}`}
      >
        {number}
      </StepNumber>
      <StepTitle hidden={!isActive} color={colorTitle || mainColor}>
        {formatTitle(stepType, type)}
      </StepTitle>
    </NavigationIconContainer>
  );
};

const NavigationIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: default;
`;

interface StepTitleProps {
  color: string;
}
const StepTitle = styled.span<StepTitleProps>`
  && {
    color: ${(props) => props.color};
  }
  ${BodyRegularMedium}
`;

interface StepNumberProps {
  isActive?: boolean;
  accentColor: string;
  color: string;
}
const StepNumber = styled.span<StepNumberProps>`
  ${BodyLargeBold}
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${(props) => (props.isActive ? props.color : props.accentColor)};
  border-radius: 100%;
  color: ${(props) => (props.isActive ? props.accentColor : props.color)};
  width: 30px;
  height: 30px;
  border: 1px solid ${(props) => (props.isActive ? 'transparent' : props.color)};
`;

export default StepNavigationIcon;
